import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import NavigationHistoryContext from "../Contexts/NavigationHistoryContext";

const useLocationHistory = () => {
  const context = useContext(NavigationHistoryContext);
  const reactRouterNavigate = useNavigate();

  if (!context) {
    throw new Error("useLocationHistory must be used within NavigationHistoryProvider");
  }

  const navigate = (path: string, label: string, clear?: boolean) => {
    context.navigate(path, label, clear);
    reactRouterNavigate(path);
  };

  return {
    items: context.items,
    navigate,
    recordVisit: context.navigate,
    clear: context.clear,
    updateCurrentLabel: context.updateCurrentLabel,
  };
};

export default useLocationHistory;
